<template>
  <div class="popBox">
    <div class="shadowbg" @click="knowFn" @touchmove.prevent />
    <div class="popBox-content">
      <img src="https://static.didapinche.com/pics/g/coupontemplate_shadowbar.png" alt="" class="shadowbar">
      <div class="popBox-title">{{ popdata.title }}</div>
      <div class="popBox-txt">
        <ul>
          <li v-for="(item,index) in popdata.txt" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="popBox-btnbox">
        <div class="btnbox-btn"><img src="https://static.didapinche.com/pics/g/coupontemplate_shadowbar.png" alt="">
          <span @click="knowFn">我知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PopBox',
    props: ['popdata'],
    data() {
      return {
        // popdata: {
        //   title: '50元顺风券包',
        //   txt: ['含3张10元顺风车出行券', '含3张10元顺风车出行券含3张元顺风车出行券含3张10元顺风车出行券含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券', '含3张10元顺风车出行券']
        // }
      }
    },
    methods: {
      knowFn() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .popBox {
    height: 100vh;
    width: 100vw;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
  }

  .shadowbg {
    height: 100vh;
    width: 100vw;
    background: #D8DDE7;
    opacity: 0.8;
  }

  .popBox-content {
    position: absolute;
    bottom: 0;
    width: 7.02rem;
    max-height: 6.7rem;
    background: #ffffff;
    left: 50%;
    box-shadow: 0 0.1rem 0.28rem 0 rgba(0, 0, 0, 0.15);
    margin-left: -3.51rem;
    border-radius: 0.24rem 0.24rem 0 0;
  }

  .shadowbar {
    position: absolute;
    width: 7rem;
    height: 0.34rem;
    left: 0;
    top: 1.18rem;
    display: block;
    margin: 0;
    transform: rotate(180deg);
    z-index: 999;
  }

  .popBox-title {
    padding: 0.4rem 0.4rem 0.3rem;
    color: #24293A;
    font-size: 0.36rem;
    font-weight: bold;
    height: 0.5rem;
  }

  .popBox-txt {
    width: 6rem;
    max-height: 3.2rem;
    color: #4E556C;
    font-size: 0.24rem;
    padding-left: 0.5rem;
    overflow-y: auto;
    padding-bottom: 1.8rem;
    padding-top: 0.2rem;
    li {
      padding-bottom: 0.16rem;
      list-style: none;
      position: relative;
      /*span{*/
        /*width: 3px;*/
        /*height: 3px;*/
        /*background:#4E556C;*/
        /*border-radius: 50%;*/
        /*display: inline-block;*/
        /*margin-right: 0.06rem;*/
        /*margin-top: 0.1rem;*/
      /*}*/
    }
    li:before{
      content: '';
      width: 3px;
      height: 3px;
      background: #4E556C;
      border-radius: 50%;
      display: inline-block;
      /*!*font-size: 0.5rem;*!*/
      /*color: #4E556C;*/
      /*transform: scale(2);*/
      /*padding-right: 0.03rem;*/
      position: absolute;
      top:0.13rem;
      left: -0.12rem;
    }
  }

  .popBox-btnbox {
    width: 7.02rem;
    position: absolute;
    bottom: 0;
    padding: 0.4rem 0 0.5rem 0;
    background: #fff;
  }

  .btnbox-btn {
    width: 6.22rem;
    height: 0.9rem;
    background: #EE9D58;
    box-shadow: 0 0.04rem 0.12rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.45rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #FFFFFF;
    font-weight: bold;
    position: relative;
    img {
      position: absolute;
      width: 7rem;
      height: 0.34rem;
      top: -0.73rem;
      display: block;
      left: -0.4rem;
    }
    span {
      display: inline-block;
      width: 6.22rem;
      height: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

</style>
